module.exports = __webpack_public_path__ + "img/70ne.0bb1c1c6.svg";